import { createContext } from 'react';

interface ContextBreadcrumbProps {
    paths: string[] | null
}

const ContextBreadcrumb = createContext<ContextBreadcrumbProps>({
    paths: null
})

export default ContextBreadcrumb;